import type { CSSProperties } from "react";

interface IntensitySliderProps {
  value: number;
  onChange: (v: number) => void;
}

export default function IntensitySlider({ value, onChange }: IntensitySliderProps) {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center gap-1.5">
        <span className="text-xs font-medium text-foreground-400">強</span>
        <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
          {value}%
        </span>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        step={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="intensity-vertical cursor-pointer"
        style={{ "--fill": `${value}%`, height: "144px" } as CSSProperties}
        aria-label="強度調整"
      />
      <span className="text-xs font-medium text-foreground-400">ソフト</span>
    </div>
  );
}